import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { motion } from 'framer-motion';
import { Formik } from 'formik';
import * as yup from 'yup';

import { GrLinkedin } from 'react-icons/gr';
import { FaDownload } from 'react-icons/fa';
import { animateScroll as scroll } from 'react-scroll';
import { backVariants, fade } from '~/styles/animations';
import { useUserContext } from '~/hooks/context/modules/UserContext';
import Loading from '~/components/Loading';
import useWindowDimensions from '~/hooks/useWindowDimensions';

import { Modal, Toast } from '~/components';

import notebook from '~/assets/img/notebook-certificado-ia-latam.png';
import logoAcelerador from '~/assets/img/semana-ia-latam.png';

import logo from '~/assets/img/logo-daxus-latam.png';
import logoWhite from '~/assets/img/Logotipo-Daxus-Branco.png';

import api from '~/services/api';

import * as U from '~/styles/utilities';
import * as F from '~/styles/form';
import * as S from './styled';

const Certificate = () => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);
  const { width } = useWindowDimensions();

  const [loading, setLoading] = useState({ form: false, image: false });

  const [modalCertificate, setModalCertificate] = useState(false);
  const [CertificateData, setCertificateData] = useState({});

  const handleSubmitForm = async (data) => {
    const formattedData = { ...data, key_word: 'ia-latam' };
    try {
      setLoading({ form: true, image: true });
      const response = await api.post('/generate-certificate', formattedData);

      setModalCertificate(true);
      setCertificateData(response.data);
      setLoading({ form: false, image: false });
    } catch (err) {
      Toast.error('Palavra-chave inválida');
      setLoading({ form: false, image: false });
    }
  };

  // form

  const initialValues = {
    username: '',
    email: '',
    key_word: '',
  };

  const validations = () =>
    yup.object().shape({
      username: yup.string().required('El nombre es obligatorio'),

      email: yup
        .string()
        .email('Introduzca un correo electrónico válido')
        .required('El e-mail es obligatorio'),
    });

  return (
    <>
      <motion.div exit={{ opacity: 0 }} initial="initial" animate="animate">
        <S.BackgroundIaLatamPage>
          <S.ContainerLimit>
            <U.Gap size={50} />
            <Grid container xs={12} justify="center">
              <Grid item xs={12} sm={4}>
                <img
                  src={logoAcelerador}
                  alt="logo"
                  style={{ width: '100%' }}
                />
              </Grid>
            </Grid>
            <U.Gap size={100} />
            <Grid container xs={12}>
              <Grid item xs={12} md={6}>
                <Grid xs={12} md={10}>
                  <motion.div variants={fade}>
                    <S.Title2>
                      <span>Felicitaciones</span> por llegar al final del evento
                    </S.Title2>
                    <U.Gap size={12} />
                    <S.Text2>
                      ¡Ahora es el momento de emitir su certificado!
                    </S.Text2>
                    <S.Text2>Aproveche este momento para:</S.Text2>
                    <U.Gap size={25} />
                    <Grid xs={12} sm={10}>
                      <S.UList2>
                        <li>
                          Compartir su certificado en <span>LinkedIN</span>
                        </li>
                        <li>
                          Seguir a <span>Daxus Latam</span> en las Redes Sociales
                        </li>
                        <li>
                          Conocer nuestra{' '}
                          <span>Curso Master Inteligencia Artificial</span> desde cero hasta el nivel más avanzado y conviértete en un profesional destacado
                        </li>
                      </S.UList2>
                    </Grid>
                    <U.Gap size={30}>
                      <S.Text>
                        ¡Gracias por seguirnos hasta aquí!
                      </S.Text>
                    </U.Gap>
                  </motion.div>
                  <Grid container xs={12} justify="center">
                    <Grid item xs={12} sm={6} md={10}>
                      <motion.div variants={fade}>
                        <img
                          src={notebook}
                          alt="logo"
                          style={{ width: '100%' }}
                        />
                      </motion.div>
                    </Grid>
                  </Grid>
                  <U.Gap size={30} />
                </Grid>
              </Grid>

              <Grid item xs={12} md={6}>
                <motion.div initial="exit" animate="enter" exit="exit">
                  <motion.div variants={backVariants}>
                    <S.Card backgroundColor="#1F1640">
                      <Grid
                        container
                        justify="space-between"
                        alignItems="center"
                      >
                        <Grid item>
                          <S.TitleModal>
                            <span>Emite tu </span> certificado
                          </S.TitleModal>
                        </Grid>
                        <Grid item>
                          <S.LogoModal src={logo} alt="logo" width='180px' />
                        </Grid>
                      </Grid>
                      <U.Gap size={20} />
                      <Formik
                        initialValues={initialValues}
                        onSubmit={handleSubmitForm}
                        validationSchema={validations()}
                      >
                        {({
                          handleSubmit,
                          handleBlur,
                          handleChange,
                          values,
                          errors,
                          touched,
                          setFieldValue,
                        }) => (
                          <>
                            <form onSubmit={handleSubmit}>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <F.Label>Nombre (máx. 30 caracteres)</F.Label>
                                  <F.Input
                                    type="text"
                                    placeholder="Escriba su nombre"
                                    name="username"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.username}
                                    maxLength={30}
                                  />
                                  {errors.username && touched.username ? (
                                    <F.Hint
                                      error={
                                        !!errors.username && touched.username
                                      }
                                    >
                                      {errors.username}
                                    </F.Hint>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12}>
                                  <F.Label>Correo registrado en el evento</F.Label>
                                  <F.Input
                                    type="email"
                                    placeholder="Escribe tu correo electrónico"
                                    name="email"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email}
                                  />
                                  {errors.email && touched.email ? (
                                    <F.Hint
                                      error={!!errors.email && touched.email}
                                    >
                                      {errors.email}
                                    </F.Hint>
                                  ) : null}
                                </Grid>

                                <Grid
                                  item
                                  xs={12}
                                  container
                                  justify="flex-end"
                                  style={{ margin: '40px 0 32px 0px' }}
                                >
                                  <S.Button
                                    // whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    full
                                    type="submit"
                                    className="flex-center"
                                    disabled={loading.form}
                                  >
                                    {loading.form ? (
                                      <>
                                        <span>Emitiendo el certificado ...</span>
                                        <Loading />
                                      </>
                                    ) : (
                                      'Emite tu Certificado!'
                                    )}
                                  </S.Button>
                                </Grid>
                              </Grid>
                            </form>
                          </>
                        )}
                      </Formik>
                    </S.Card>
                  </motion.div>
                </motion.div>
              </Grid>
            </Grid>
            <U.Gap size={100} />
          </S.ContainerLimit>
        </S.BackgroundIaLatamPage>

        <S.SeeMoreSection>
          <S.ContainerLimit>
            <Grid container justify="center" className="text-center">
              <Grid>
                <S.TitleBig>Ver más sobre </S.TitleBig>
                <S.TitleBig>
                  <span>Daxus Latam</span>
                </S.TitleBig>
              </Grid>
            </Grid>
            <U.Gap size={50} />
            <Grid container xs={12} justify="center">
              <Grid item container xs={12} spacing={3}>
                <Grid item xs={12} lg={4}>
                  <a
                    href="https://www.daxus.com/master-ia"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <S.ButtonFooter2 whileTap={{ scale: 0.95 }}>
                      CURSO MASTER INTELIGENCIA ARTIFICIAL
                    </S.ButtonFooter2>
                  </a>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <a
                    href="https://www.instagram.com/daxuslatam/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <S.ButtonFooter2 whileTap={{ scale: 0.95 }}>
                      Instagram
                    </S.ButtonFooter2>
                  </a>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <a
                    href="https://www.linkedin.com/company/daxus-latam/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <S.ButtonFooter2 whileTap={{ scale: 0.95 }}>
                      LINKEDIN
                    </S.ButtonFooter2>
                  </a>
                </Grid>
              </Grid>
            </Grid>
          </S.ContainerLimit>
        </S.SeeMoreSection>

        <Grid container justify="center" className="text-center">
          <Grid>
            <U.Gap size={20} />
            <img src={logoWhite} alt="logo-branca" style={{ width: '90px', marginBottom: '20px' }} />

            <S.Text>Daxus Latam | Empowerdata ahora es Daxus Latam © 2025 - CNPJ: 37.737.207/0001-53</S.Text>
            <U.Text>Reservados todos los derechos</U.Text>
            <U.Gap size={20} />
          </Grid>
        </Grid>
      </motion.div>

      {modalCertificate && (
        <Modal
          onClose={() => setModalCertificate(false)}
          hasButton
          size={70}
          white
          contentPadding={width > 768 ? '2rem' : '4rem 1.5rem 1.5rem 1.5rem'}
        >
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              md={8}
              container
              alignItems="center"
              justify="center"
            >
              {!loading.image && (
                <Grid
                  item
                  xs={12}
                  md={8}
                  container
                  alignItems="center"
                  justify="center"
                  style={{ height: 460 }}
                >
                  <Loading />
                </Grid>
              )}
              <img
                src={CertificateData.certificate_image}
                alt="certificado"
                style={loading.image ? { width: '100%' } : { display: 'none' }}
                onLoad={() => setLoading({ form: false, image: true })}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <U.Gap size={width > 768 ? 50 : 0} />
              <S.TitleCertificate>
                ¡Felicitaciones, {CertificateData.name}!
              </S.TitleCertificate>
              <U.Gap size={width > 768 ? 20 : 10} />
              <U.Text black bold>
                ¡Aprovecha y comparte este logro en tu LinkedIn!
              </U.Text>

              <U.Gap size={30} />
              <a
                href={`https://www.linkedin.com/shareArticle?mini=true&url=${CertificateData.certificate_image}`}
                target="_blank"
                rel="noreferrer"
              >
                <S.ButtonFooter whileTap={{ scale: 0.95 }}>
                  <GrLinkedin size={20} color="#fff" /> Compartir en LinkedIn
                </S.ButtonFooter>
              </a>
              <U.Gap size={20} />
              <a
                href={CertificateData.certificate}
                download="certificado.pdf"
                target="_blank"
                rel="noreferrer"
              >
                <S.ButtonFooter whileTap={{ scale: 0.95 }}>
                  <FaDownload size={20} color="#fff" /> Descargar certificado
                </S.ButtonFooter>
              </a>
            </Grid>
          </Grid>
        </Modal>
      )}
    </>
  );
};

export default Certificate;
